/* global RaEventTracker */
// src/util/tracker.js
// 注意事项
// 如果需要查看当前文件，需要检查index.html文件有没有引入<script src="https://tsource.rastargames.com/libs/tracker.umd-0.0.4.js"></script>
// 没有引用就会初始化不成功

// 初始化跟踪器实例
const initTracker = () => {
  try {
    if (typeof RaEventTracker === "undefined") {
      throw new Error("[RaEventTracker] 依赖脚本未正确加载");
    }

    const tracker = new RaEventTracker(
      { url: "https://collect.rastargames.com/v1/webevent/collect/" },
      { siteId: "fvOd559ZHDReOBVH" },
      "5BdkuJHg3rlKQx?g"
    );

    console.log("RaEventTracker 初始化成功");
    return tracker;
  } catch (error) {
    console.error("初始化 RaEventTracker 失败:", error);
    // 根据需要处理错误，例如重试或通知用户
  }
};

// 自定义指令 v-track
// 支持两种埋点模式：GA 埋点（通过 class）和内部埋点（通过 tracker）
const trackDirective = {
  mounted(el, binding) {
    const { value } = binding;
    if (value) {
      // 自动添加对应的 class（用于 GA 埋点）
      el.classList.add(value);

      // 添加点击事件监听
      el.addEventListener("click", () => {
        // 内部埋点
        const tracker = window.$tracker;
        if (tracker && tracker.push) {
          tracker.push(value);
          console.log("统计 name ==", value);
        }
      });
    }
  },
};

// 定义 Vue 插件
export default {
  install(app) {
    const tracker = initTracker();

    // 方案 1：挂载到全局属性（兼容 Options API）
    app.config.globalProperties.$tracker = tracker;

    // 方案 2：通过 provide 注入（推荐 Composition API）
    app.provide("tracker", tracker);

    // 方案 3：挂载到 window（供自定义指令使用）
    if (typeof window !== "undefined") {
      window.$tracker = tracker;
    }

    // 注册自定义指令 v-track
    app.directive("track", trackDirective);
  },
};
